import config from '@/config/index';

/**
 * ES搜索 -  机构搜索
 * @param tag            tag
 * @param industrycategory        industrycategory
 * @param page           当前第几页
 * @param limit          限制多少页
 * @param request
 * @return
 */
function searchorg() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchorg`;
}
/**
 * ES搜索 -  产品搜索
 * @param producttype
 * @param page           当前第几页
 * @param limit          限制多少页
 * @param request
 * @GetMapping("/searchproduct")
 */
function searchproduct() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchproduct`;
}

/**
 * ES搜索 -  服务搜索
 * @param servicecategory
 * @param industrycategory
 * @param page           当前第几页
 * @param limit          限制多少页
 * @param request
 * @return@GetMapping("/searchservice")
 */
function searchservice() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchservice`;
}


export {
  searchorg,
  searchproduct,
  searchservice,
};
